<template>
  <div id="app">
    <v-app>
      <v-content>
        <CustomerVerification v-if="verifyUser" />
        <PrivacyAndPolicy v-else-if="privacyAndPolicy" />
        <template v-else>
          <template v-if="!logged_in">

            <staff-login
              v-if="adminLogin"
              :changeLogin="changeLogin"
            />

            <!-- customer login -->
            <login-component
              v-else-if="!adminLogin"
              :changeLogin="changeLogin"
              :changePhoneLogin="changePhoneLogin"
            />

            <!-- <customer-registration @logged-in="handleLogin" /> -->
          </template>
          <page-container v-if="logged_in"></page-container>
        </template>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import loginComponent from './components/loginComponent.vue'
// import customerRegistration from './components/customerRegistration.vue'
import staffLogin from './components/staffLogin.vue'
import pageContainer from './components/pageContainer.vue'
import axios from 'axios'
import swal from 'sweetalert'
import CustomerVerification from './components/customerVerification/CustomerVerification.vue'
import PrivacyAndPolicy from './PrivacyAndPolicy.vue'

export default {
  name: 'app',
  data() {
    return {
      logged_in: localStorage.getItem('logged_in'),
      url: 'api/login',
      userData: {},
      adminLogin: false,
      verifyUser: false,
      privacyAndPolicy: false
    }
  },

  mounted() {
    if (this.logged_in) {
      this.getUserPermissions(localStorage.getItem('access_token'))
    }

    if (this.$router.currentRoute.fullPath === '/customer-verification') {
      this.verifyUser = true
    } else if (this.$router.currentRoute.fullPath === '/privacy-and-policy') {
      this.privacyAndPolicy = true
    } else if (this.$router.currentRoute.fullPath === '/shipzone-admin') {
      this.adminLogin = true
    }
  },

  watch: {
    $route() {
      if (this.$router.currentRoute.fullPath === '/customer-verification') {
        this.verifyUser = true
      } else {
        this.verifyUser = false
      }

      if (this.$router.currentRoute.fullPath === '/privacy-and-policy') {
        this.privacyAndPolicy = true
      } else {
        this.privacyAndPolicy = false
      }

      if (!this.logged_in) {
        this.$router.push('login')
      }
    }
  },

  methods: {
    handleLogin(token) {
      localStorage.setItem('access_token', token)
      this.getUser(localStorage.getItem('access_token'))
      this.getUserPermissions(localStorage.getItem('access_token'))
    },

    changeLogin(loginData) {
      axios
        .post(this.url, loginData)
        .then(response => {
          this.handleLogin(response.data.access_token)
        })
        .catch(error => {
          if (error.response) {
            swal('Error', `${error.response.data.message}`, 'error')
          }
        })
    },

    changePhoneLogin(form) {
      axios
        .post('api/phone-login', form)
        .then(response => {
          this.handleLogin(response.data.access_token)
        })
        .catch(error => {
          if (error.response) {
            swal('Error', `${error.response.data.message}`, 'error')
          }
        })
    },

    getUserPermissions(token) {
      axios
        .get('api/auth_user_permissions', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          localStorage.setItem('user_permissions', JSON.stringify(response.data))
        })
    },

    getUser(token) {
      axios
        .get('api/me', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          localStorage.setItem('user_data', JSON.stringify(response.data))
          this.userData = JSON.parse(localStorage.getItem('user_data'))
        })
        .then(() => {
          if (this.userData.is_staff) {
            this.checkExpiredCoupons()
            localStorage.setItem('logged_in', true)
            this.logged_in = localStorage.getItem('logged_in')
            localStorage.setItem('secret_key', false)
          } else {
            console.log('else')
            if (
              !this.userData.phone_number ||
              !this.userData.full_name ||
              !this.userData.email ||
              !this.userData.address
            ) {
              console.log('else -> if')
              localStorage.setItem('logged_in', true)
              this.logged_in = localStorage.getItem('logged_in')
              this.$router.push('/')
            } else {
              console.log('else -> else')
              localStorage.setItem('logged_in', true)
              this.logged_in = localStorage.getItem('logged_in')
              this.$router.push('/make-new-order')
            }
          }
          setTimeout(function () {
            location.reload(true)
          }, 1)
        })
    },

    checkExpiredCoupons() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/check_expired_coupons', {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => { })
    }
  },
  components: {
    'login-component': loginComponent,
    'page-container': pageContainer,
    'staff-login': staffLogin,
    // customerRegistration,
    CustomerVerification,
    PrivacyAndPolicy
  }
}
</script>
<style>
.ws-nowrap {
  white-space: nowrap !important;
}

.hover-container {
  position: relative;
}

.hover-container:hover .hover-content {
  visibility: visible;
  opacity: 1;
}

.hover-content {
  visibility: hidden;
  opacity: 0;
  transition: all 0.3 linear;
  position: absolute;
  top: -10px;
  right: 130px;
  z-index: 1000;
  background-color: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 8px !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 8px 16px;
  width: 310px;
}

.popover-arrow {
  position: absolute;
  top: 25px;
  right: -7px;
  z-index: 3000;
  height: 13px;
  width: 13px;
  border-radius: 0px;
  border: 1px solid #e4e7ed;
  background: #fff;
  transform: rotate(135deg);
  border-bottom: none;
  border-right: none;
}

.popover-arrow-left {
  position: absolute;
  top: 25px;
  left: -7px;
  z-index: 3000;
  height: 13px;
  width: 13px;
  border-radius: 0px;
  border: 1px solid #e4e7ed;
  background: #fff;
  transform: rotate(-45deg);
  border-bottom: none;
  border-right: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue